import { AUTH_USER, REMOVE_AUTH_USER } from "../../constants/ActionTypes";
import user from "../../constants/Admin";

const Initial_State = {
  user: user,
};

const AdminReducer = (state = Initial_State, action) => {
  switch (action.type) {
    case AUTH_USER:
      return {
        ...state,
        user: action.user,
      };

    case REMOVE_AUTH_USER:
      return {
        user: [],
      };

    //   case INIT_URL: {
    //     return {
    //       ...state,
    //       initURL: action.payload
    //     }
    //   }
    default:
      return state;
  }
};

export default AdminReducer;
